// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    customerId: z.string().min(1, 'Required'),
    meterId: z.string().min(1, 'Required'),
    meterValue: z.number({invalid_type_error: 'Required'}),
    timestamp: z.string().min(1, 'Required'),
    dimensions: z.array(z.object({
        apiKey: z.string().min(1, 'Required'),
        value: z.string().min(1, 'Required'),
    })).optional(),
});
